import { Button, Loading, QuickEdit } from '../../../../components';
import { useUserContext } from '../../../../context/PermissionsContext';
import { FindSectionOwnerByPlan } from '../BCPLanding';

type OwnersInformationLandingProps = {
  data: FindSectionOwnerByPlan;
  setModalEditOpen: (value: React.SetStateAction<boolean>) => void;
  isLocationType?: boolean;
  loading?: boolean;
};

const OwnersInformationLanding = ({
  data,
  setModalEditOpen,
  isLocationType = true,
  loading,
}: OwnersInformationLandingProps) => {
  const { isAdmin, canEdit } = useUserContext();
  if (loading) return <Loading />;

  return (
    <div className="flex flex-col gap-3.5">
      <div className="flex items-center gap-4 mr-7">
        <span className="min-w-[168px] text-primary-100 font-semibold">
          {isLocationType ? 'Location' : 'Corporate'} BCP Owner
        </span>
        <div className="rounded-md input-blueish-background border border-borders flex-1 py-1.5 px-3 text-primary-100">
          {`${
            data?.sectionOwnerfirstName.trim()
              ? `${data?.sectionOwnerfirstName} ${data?.sectionOwnerlastName}`
              : 'N/A'
          } `}
        </div>
      </div>
      <div className="flex items-center gap-4 mr-7">
        <span className="min-w-[168px] text-primary-100 font-semibold">
          Email
        </span>
        <div className="rounded-md input-blueish-background border border-borders flex-1 py-1.5 px-3 text-primary-100">
          {`${data?.email.trim() ? data.email : 'N/A'} `}
        </div>
      </div>
      <div className="absolute right-3 top-3">
        {(isAdmin || canEdit) && (
          <Button type="edit" onClick={() => setModalEditOpen(true)}>
            <QuickEdit />
          </Button>
        )}
      </div>
    </div>
  );
};

export default OwnersInformationLanding;
